import React, { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaUser, FaSignOutAlt, FaSearch, FaShoppingCart, FaBars, FaTimes } from 'react-icons/fa';
import { AuthContext } from '../context/AuthContext';
import { CartContext } from '../context/CartContext';
import './Header.css';

const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const { cart } = useContext(CartContext);
  const location = useLocation();
  const [showShopDropdown, setShowShopDropdown] = useState(false);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const cartItemsCount = cart?.reduce((total, item) => total + item.quantity, 0) || 0;

  // Determine page theme based on current route
  const getPageTheme = () => {
    const path = location.pathname;
    if (path === '/') return 'home';
    if (path.startsWith('/products')) return 'products';
    if (path.startsWith('/cart')) return 'cart';
    if (path.startsWith('/custom-studio')) return 'custom';
    if (path.startsWith('/admin')) return 'admin';
    if (path.startsWith('/login') || path.startsWith('/register')) return 'auth';
    return 'default';
  };

  const pageTheme = getPageTheme();

  return (
    <header className={`header header-${pageTheme}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <h1>Alok Electronics and Furnitures</h1>
          </Link>
          
          <button 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>

          <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <div 
              className="nav-item dropdown"
              onMouseEnter={() => setShowShopDropdown(true)}
              onMouseLeave={() => setShowShopDropdown(false)}
            >
              <Link to="/products" className={location.pathname.startsWith('/products') ? 'active' : ''}>Shop</Link>
              {showShopDropdown && (
                <div className="dropdown-menu">
                  <Link to="/products?category=living">Living Room</Link>
                  <Link to="/products?category=dining">Dining Room</Link>
                  <Link to="/products?category=bedroom">Bedroom</Link>
                  <Link to="/products">All Products</Link>
                </div>
              )}
            </div>

            <div 
              className="nav-item dropdown"
              onMouseEnter={() => setShowServicesDropdown(true)}
              onMouseLeave={() => setShowServicesDropdown(false)}
            >
              <Link to="/services" className={location.pathname.startsWith('/services') ? 'active' : ''}>Services</Link>
              {showServicesDropdown && (
                <div className="dropdown-menu">
                  <Link to="/services/repair">Sofa Repair</Link>
                  <Link to="/services/upholstery">Upholstery</Link>
                  <Link to="/services/restoration">Restoration</Link>
                </div>
              )}
            </div>

            <Link to="/custom-studio" className={`nav-item ${location.pathname === '/custom-studio' ? 'active' : ''}`}>
              Custom Studio
            </Link>
          </nav>

          <div className="header-actions">
            <button className="icon-btn" aria-label="Search">
              <FaSearch />
            </button>

            <Link to="/cart" className="cart-icon" aria-label="Shopping cart">
              <FaShoppingCart />
              {cartItemsCount > 0 && (
                <span className="cart-count">{cartItemsCount}</span>
              )}
            </Link>

            {user ? (
              <div className="user-menu">
                <Link to="/profile" className="icon-btn" aria-label="Profile">
                  <FaUser />
                </Link>
                {user.isAdmin && (
                  <Link to="/admin" className="admin-link">
                    Admin Dashboard
                  </Link>
                )}
                <button onClick={logout} className="icon-btn" aria-label="Logout">
                  <FaSignOutAlt />
                </button>
              </div>
            ) : (
              <Link to="/login" className="icon-btn">
                <FaUser />
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
